import React from 'react'
import { connect } from 'react-redux'
import { logoff } from '../../ducks/Auth'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faBars, faTimes } from '@fortawesome/fontawesome-free-solid'
import { Navbar, Nav, NavDropdown, MenuItem } from 'react-bootstrap'

class HeaderLinks extends React.Component {
    render() {
        return (
            <div>
                <Navbar.Form pullLeft className="navbar-search-form">
                </Navbar.Form>
                <Nav pullRight>
                    <NavDropdown
                        eventKey={4}
                        title={(
                            <div className="text-default">
                                <FontAwesomeIcon icon={faBars} className="text-default" />
                                {/* <i className="fa fa-list"></i> */}
                                <p className="hidden-sm hidden-md">

                                    <b className="caret"></b>
                                </p>
                            </div>
                        )} noCaret id="basic-nav-dropdown-3" bsClass="dropdown-with-icons dropdown">
                        <MenuItem eventKey={4.5} onClick={() => this._handleLogoff()}>
                            <div className="text-danger">
                                <i className="pe-7s-close-circle"></i> Sair
                            </div>
                        </MenuItem>
                    </NavDropdown>
                </Nav>
            </div>
        )
    }

    _handleLogoff = () => {
        this.props.logoff()
    }
}
export default connect(null, { logoff })(HeaderLinks)



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx